import React, { Component } from 'react'
import { Link } from 'react-router'
import classnames from 'classnames'

import Icon from '../util/Icon'

export default class OrderableTH extends Component {
  getIcon() {
    const { query: { order_by, order_dir }, field } = this.props
    return (
      <span className="fa-stack">
        <Icon icon="caret-up" className={classnames('fa-stack-1x', { selected: order_by === field && order_dir === 'desc' })} />
        <Icon icon="caret-down" className={classnames('fa-stack-1x', { selected: order_by === field && order_dir === 'asc' })} />
      </span>
    )
  }

  getLink() {
    const { query, field, defaultDesc } = this.props
    const page = query.page && 1
    const order_by = field
    let order_dir = defaultDesc ? 'desc' : 'asc'
    if (query.order_by === field){
      order_dir = (query.order_dir === 'desc') ? 'asc' : 'desc'
    }
    return (
      <Link
        to={location => ({ ...location, query: { ...location.query, ...query, order_by, order_dir, page } })}>
        {this.getIcon()} {this.props.children}
      </Link>
    )
  }

  render() {
    const { query, field, defaultDesc, className, ...props } = this.props
    const classname = classnames('orderable', className)
    return (
      <th className={classname} {...props}>
        {this.getLink()}
      </th>
    )
  }
}



// WEBPACK FOOTER //
// client/components/navigation/OrderableTH.js